import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100.05",
  y1: "149.515",
  x2: "100.05",
  y2: "9.91"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M177.1 61c0-5.1-1.4-10.1-4.1-14.4-2.7-4.3-6.6-7.8-11.1-9.9l-51.4-24.2c-3.5-1.7-7.3-2.5-11.1-2.5s-7.5.8-11 2.5L38 36.6c-4.5 2.2-8.3 5.6-11 9.9s-4.1 9.2-4.1 14.3v54.8c0 45.7 51.1 66.9 70.2 73.2 4.7 1.6 9.7 1.5 14.3-.1 19.1-6.7 69.8-28.6 69.8-73.1l-.1-54.6zm-44.8 27.4-36.4 36.2c-1.5 1.4-3.4 2.2-5.4 2.2s-3.8-.8-5.2-2.2l-17.1-16.7c-3-2.9-3.1-7.8-.2-10.9 2.9-3.1 7.7-3.2 10.7-.2l11.8 11.6 31.2-31c1.4-1.4 3.4-2.2 5.4-2.1 2 0 3.9.9 5.3 2.3s2.2 3.4 2.1 5.4c0 2-.8 4-2.2 5.4z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}